import { useRef, useState } from 'react';
import { CustomFloatingFilterProps } from 'ag-grid-react';
import { TagsService } from '$/services';
import * as Bixby from '$/core';

export default ({ onModelChange, ...props }: CustomFloatingFilterProps) => {
  const dispatchToastError: (message: string) => void = (props.filterParams as any).dispatchToastError;
  const inputRef = useRef<HTMLInputElement>(null);
  const [companyResults, setCompanyResults] = useState<Bixby.Models.TagSuggestion[] | undefined>([]);

  const onSearchChange = async (text: string) => {
    // reset results if there is no text
    if (!text) {
      setCompanyResults([]);
      onModelChange(null);
      return;
    }

    // if there is only blank space, reset the text input
    text = (text || '').trimStart();
    if (text === '' && inputRef.current) {
      inputRef.current.value = text;
      return;
    }

    // if we have a match by name, find the suggestion and notify the grid
    const chosenCompanyIndex: number = (companyResults || []).findIndex(x => x.name === text);
    if (chosenCompanyIndex !== -1) {
      const chosenCompany: Bixby.Models.TagSuggestion = (companyResults || [])[chosenCompanyIndex];
      onModelChange(chosenCompany);
      return;
    }

    // else search for new suggestions
    try {
      const results: Bixby.Models.TagSuggestion[] = await TagsService.getSuggestionsAsync({
        term: text,
        take: 10,
      } as Bixby.Models.TagsRequest);

      setCompanyResults(results);
    } catch (e: any) {
      dispatchToastError('Error fetching CreditSights companies');
    }
  };

  const handleClearClick = () => {
    handleClear();
  };

  const handleClearKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    const code = e.code;

    if (code === 'Enter') {
      handleClear();
    } else if (code === 'Space') {
      handleClear();
    }
  };

  const handleClear = () => {
    setCompanyResults([]);
    onModelChange(null);

    if (inputRef.current) {
      inputRef.current.value = '';
    }
    return;
  };

  return (
    <div className="ag-floating-filter-input" role="presentation">
      <div role="presentation" className="ag-text-field ag-input-field">
        <div
          className="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper covenantReviewCompanyFloatingFilter"
          role="presentation">
          <input
            ref={inputRef}
            list="covenant-review-company-results"
            className="ag-input-field-input ag-text-field-input"
            type="text"
            placeholder="Filter..."
            aria-label="Filter Value"
            onChange={({ target: { value } }) => onSearchChange(value)}
          />
          <span
            role="button"
            tabIndex={0}
            className="clear"
            onClick={handleClearClick}
            onKeyDown={handleClearKeyDown}
          />
          <datalist id="covenant-review-company-results">
            {(companyResults || []).map(c => {
              return <option key={c.id}>{c.name}</option>;
            })}
          </datalist>
        </div>
      </div>
    </div>
  );
};
